import cn from 'classnames';
import { FormCheckProps } from 'react-bootstrap';
import { Background, BackgroundType, Size, SizeType } from '../designConstants';

export interface FormCheckBaseProps extends Omit<FormCheckProps, 'type' | 'size'> {
  size?: SizeType;
  background?: BackgroundType;
}

export const formCheckClassName = (
  {
    size = Size.MD,
    background = Background.LIGHT
  }: Pick<FormCheckBaseProps, 'size' | 'background'>,
  extra?: string
) => cn('tnt-form-check', size, background, extra);
